import { Observable } from 'rxjs';

import { SnCamera, SnCitizenIncidentDetails, SnCitizenVideoStream } from '@lib/api/entities';
import { ICitizenMarker } from '@lib/cameras';

import { IFsMap } from '../types';

export abstract class FsMapCitizenServiceProvider<TMap extends IFsMap> {
  abstract readonly id: string;
  abstract readonly geospatialProvider: string;

  // Properties
  abstract readonly canChange: boolean;
  abstract readonly isAvailable: boolean;
  abstract mapMarkers: ICitizenMarker[];

  // Observables
  abstract get hovered$(): Observable<SnCitizenVideoStream>;
  abstract get cameraSelected$(): Observable<SnCitizenVideoStream>;

  // Map lifecycle methods
  abstract onMapLoaded(map: TMap): void;
  abstract addToMap(): void;
  abstract removeFromMap(): void;

  // Incident and camera management
  // abstract _selectAndZoomToCamera(incident: SnCitizenIncidentDetails): void;
  abstract cameraHovered(camera: SnCitizenVideoStream): void;
  abstract openPopup(incident: SnCitizenIncidentDetails): void;
  abstract closePopup(): void;

  // Polyline management
  abstract addPolyline(camera: SnCitizenVideoStream, element: Element): void;
  abstract addPolylines(cameras: SnCamera[]): void;
  abstract removePolyline(): void;
  abstract removeLine(): void;
  abstract clearPolylines(): void;

  // Coordinate conversion
  abstract point2LatLng(x: number, y: number): unknown;
}
